import { Injectable } from '@angular/core';
import { Project } from './project';
import { Topic } from './topic';
import { DbRecord } from './db-record';
import { Tag } from './tag';
import { Note } from './note';
import { SearchTerm } from './search-term';
import { SearchTermService } from './search-term.service';
import { ExportParserService } from './export-parser.service';
import { ArcService } from './arc.service';
import { UtilsService } from './utils.service';
import { TopicService } from './topic.service';
import { TagService } from './tag.service';
import { NoteService } from './note.service';
import { FileService } from './file.service';
import { DbRecordService } from './db-record.service';
import { CriterionService } from './criterion.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { BatchSearchService } from './batch-search.service';

@Injectable()
export class ProjectService {
  projectMap = new Map<string, Project>();
  topics: TopicService;
  tags: TagService;
  sts: SearchTermService;
  cs: CriterionService;
  ns: NoteService;
  startLocation: string[];
  private _dbRecordsLsCache;

  constructor(
    private router: Router,
    private eps: ExportParserService,
    private arcs: ArcService,
    private utils: UtilsService,
    private fs: FileService,
    private dbrs: DbRecordService,
    private bss: BatchSearchService,
  ) {
    this.arcs.projects = this;
    this.startLocation = location.pathname.split('/').splice(1);
  }

  getDbRecord(recordId: string) {
    return this.dbrs.getDbRecord(recordId);
  }

  set recordsCache(ls) {
    this._dbRecordsLsCache = ls;
  }

  get recordsCache() {
    return this._dbRecordsLsCache;
  }

  prepareProjects() {
    let pid = localStorage.getItem('currentProject');
    let obs = this.arcs.run({ fun: 'init' });
    obs.subscribe(resp => {
      resp['projects'].forEach((p) => new Project(this, p['id'], p['title']));
      resp['shortcuts'].forEach(s => {
        const p = this.projectMap.get(s['projectId']);
        if (p) {
          p.shortcut = s.shortcut;
        };
        if (pid) {
          this.router.navigate(['project', pid]);
        }
      });
    });
  }

  initProject(p: Project) {
    let obs = this.arcs.run({
      fun: 'initProject',
      projectId: p.id
    });

    obs.subscribe((resp) => {
      console.log('RESPONSE initProject', resp);
      let obs2 = this.arcs.run({
        fun: 'getListOfUploadedFiles',
        project: p.shortcut
      });
      obs2.subscribe((resp2) => {
        console.log('UUU', resp2)
        resp2['files'].forEach((obj) => this.fs.newFromSaved(obj));
      });
      this.eps.initFiles(resp['searchFiles'], resp['excludeRecordsFile']);
      resp['binding'].forEach((tpl) => p.topicsSearchTermsMap.set(tpl[0],
        new Set<string>(tpl[1])));
      resp['topics'].forEach((t) => this.topics.newFromSaved(p, t));
      resp['searchTerms'].forEach((st) => this.sts.newFromSaved(p, st));
      resp['tags'].forEach((tag) => this.tags.newFromSaved(p, tag));
      this.tags.exportTagsSet = new Set<string>(resp['exportedTags']['exportedTags']);

      resp['criterions'].forEach((c) => this.cs.newFromSaved(p, c));
      resp['notes'].forEach((n) => this.ns.newFromSaved(p, n));
      this.initManual(resp['manualFile']);
      this.initRepair(p, resp['repairFile']);
      p.initTopicDbRecords(resp['topicDbRecordsFile']);
      this.bss.init(p);
      if (this.startLocation.length) {
        this.router.navigate(this.startLocation);
        this.startLocation = [];
      }
    });
    return obs;
  }


  initManual(params) {
    if (!params) {
      return;
    }
    Object.keys(params).forEach((k) => {
      let obj = params[k];
      obj['isManual'] = true;
      let dbr = this.dbrs.create(obj);
      console.log(dbr);
    });
  }

  initRepair(project: Project, params) {
    if (!params) {
      return;
    }
    this.dbrs.repairMap.set(project.id, params);
  }

  get list() {
    let ls = Array.from(this.projectMap.values());
    return ls.sort((a, b) => a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1);
  }

  get(pid) {
    return this.projectMap.get(pid);
  }

  newProject() {
    let pid = this.utils.uniqueIdentifier;
    if (!pid) {
      return;
    }
    return new Project(this, pid, '');
  }

  saveTopicSearchTermBinding(p: Project): Observable<any> {
    let ls = [];
    p.topicsSearchTermsMap.forEach((sss, k) =>
      ls.push([k, Array.from(sss)]));

    let obs = this.arcs.run({
      fun: 'saveTopicSearchTermBinding',
      projectId: p.id,
      binding: ls
    });
    obs.subscribe((resp) => console.log(8877, resp));
    return obs;
  }

  saveDbRecordTopic(
    p: Project,
    dbRecordId: string,
    topicId: string,
    note?: [string, Date]
  ) {
    let obs = this.arcs.run({
      fun: 'saveDbRecordTopic',
      projectId: p.id,
      topicId: topicId,
      dbRecordId: dbRecordId,
      note: note || ['', null]
    });
    obs.subscribe((resp) => resp);
    return obs;
  }

  deleteDbRecordTopic(
    p: Project,
    dbRecordId: string,
    topicId: string,
  ) {
    let obs = this.arcs.run({
      fun: 'deleteDbRecordTopic',
      projectId: p.id,
      topicId: topicId,
      dbRecordId: dbRecordId,
    });
    obs.subscribe((resp) => console.log('DELETE DBRECORDTOPIC', resp));
    return obs;
  }

  initDbRecordTopicNotes(p: Project, ls) {
    let tnCounter = 1;
    ls.forEach(tpl => {
      this.ns.createNote({
        id: `tn${tnCounter++}`,
        parentId: tpl[1],
        topic: p.topicsMap.get(tpl[0]),
        project: p,
        text: tpl[2],
        date: tpl[3]
      });
    });
  }

  save(p: Project): Observable<any> {
    p.isNew = false;
    let obs = this.arcs.run({
      fun: 'saveProject',
      title: p.title,
      shortcut: p.shortcut,
      id: p.id
    });
    obs.subscribe((resp) => (resp));
    return obs;
  }

  delete(p: Project): Observable<any> {
    let obs = this.arcs.run({
      fun: 'deleteProject',
      id: p.id
    });
    obs.subscribe((resp) => this.projectMap.delete(p.id));
    return obs;
  }

}



// WEBPACK FOOTER //
// ./src/app/project.service.ts